<template>
  <div class="">
    <com-head :leadtext="toptext"></com-head>
    <div class="menu-key">
       <p class="enter-text">部分代表企业  <span>&nbsp;&nbsp;(内容由CPS中安网撰写)</span> </p>
      <ul class="entimg">
        <li
          v-for="(list, index) in listimg"
          :class="{ selected: index == isactive }"
          @click="entclick(index)"
        >
          <img :src="list.logo" alt="" />
        </li>
      </ul>
    </div>
    <div class="menu-key">
      <div class="key-content">
        <div class="keycon-title">
          <h3>{{ contitle }}</h3>
          <div class="aa"></div>
        </div>
        <div v-html="content" id="content-style-sch"></div>
      </div>
    </div>
  </div>
</template>

<script>
import comhead from "./comhead.vue";
import { trend } from "../api/api";

export default {
  components: {
    "com-head": comhead,
  },
  data() {
    return {
      isactive: 0, //默认第一个有样式
      toptext:
        "资本市场善于追逐和围猎风口行业，安防实体借助前沿技术赋能，急需募资扩产增值，上市之道，乃双方需求匹配的最佳方案。然，上市非终点，而是起点，是企业发展万里新征程的开端。",
      antarray: [
        {
          content: "",
          create_time: 0,
          keyword: "",
          title: "",
        },
      ],
      listimg: [
        {
          id: 0,
          image: "",
          pid: 0,
          title: "",
        },
      ],
      contitle: "",
      content: "",
      id: 0,
      // 关键词默认值
      activeName: "0",

      //折叠面板默认值
      activeNames: ["1"],
    };
  },
  methods: {
    //获取数据
    getData: function () {
      var gain = {
        cate_id: 32,
        where: "[year,=,2020]",
        limit: 40,
      };
      trend(gain).then((res) => {
        this.listimg = res.data.list;
        console.log(res.data.list);
        this.entclick(0);
      });
    },
    entclick: function (id) {
      console.log(id);
      this.contitle = this.listimg[id].title;
      this.content = this.listimg[id].content;
      //this.listimg[id].content
      this.isactive = id;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
@import "../assets/public.less";
.menu-key{
  padding: 30px;
}
.selected {
  border: 2px solid !important;
  border-image: linear-gradient(
      270deg,
      rgba(56, 18, 178, 0.5),
      rgba(250, 29, 129, 0.5)
    )
    4 4 !important;
}
.key-content {
  border-top: 0;
  padding: 50px;
}

/deep/.key-content h5 {
  font-family: PingFang SC;
  margin-top: 30px !important;
  text-align: left;
  margin: 30px 0px;
  margin-left: -30px;
}
#content-style-tre {
  color: #666666;
  width: 100%;
  margin-top: 30px;
}
</style>
<style scoped>
/* 表格样式 */
.key-content >>> table {
  width: 100% !important;
  font-size: 12px !important;
}
.key-content >>> table tr {
  height: 41px !important;
  border-top: 1px solid #ececec !important;
  text-align: center !important;
}
.key-content >>> table tr:nth-child(1) td {
  font-size: 18px !important;
  color: #666666 !important;
}
.key-content >>> table tr td {
  font-size: 16px !important;
  color: #666666 !important;
  border-bottom: 1px solid #ececec !important;
}
.key-content >>> table tr td span {
  color: #666666 !important;
}
.key-content >>> table tbody tr:nth-child(1) {
  background: #f9f9fa !important;
  font-weight: bold !important;
  text-align: center !important;
}

.key-content >>>  p{
  text-align: justify;
  font-size: 16px;
  color: #444444;
  padding: 0px 20px;
  line-height: 30px;
}
.key-content >>> h5{
  color: #fff;
  height: 46px;
  background-color: #6F53C7;
  background-image: linear-gradient(to right, #FA1D80 , #3712B2);
  opacity: 0.7;
  margin: 0 auto;
}
.key-content >>> h5 span{
  font-size: 30px !important;
  line-height: 46px;
}
</style>


// WEBPACK FOOTER //
// src/components/appear.vue